const pdf = {
  fpplus: require("./fpplus.pdf"),
};

export default pdf;
